// ============================================================================
// UNIVERSAL ACTION HANDLERS - VIEW ACTIONS
// ============================================================================

import type { UniversalActionHandlers } from "./types";

/**
 * Enhanced View Actions - Navigate to detail pages with better error handling
 */
export const viewActions: UniversalActionHandlers = {
  // View contact details
  viewContact: async (item, context) => {
    const contactId = item.contact_id || item.id;
    if (contactId) {
      context.onNavigate(`/contacts/${contactId}`);
    } else {
      context.onToast("No contact ID available", "warning");
    }
  },

  // View ticket details
  viewTicket: async (item, context) => {
    const ticketId = item.ticket_id || item.id;
    if (ticketId) {
      context.onNavigate(`/tickets/${ticketId}`);
    } else {
      context.onToast("No ticket ID available", "warning");
    }
  },

  // View task details
  viewTask: async (item, context) => {
    const taskId = item.task_id || item.id;
    if (taskId) {
      context.onNavigate(`/tasks/${taskId}`);
    } else {
      context.onToast("No task ID available", "warning");
    }
  },

  // View time entry details
  viewTimeEntry: async (item, context) => {
    const timeEntryId = item.time_entry_id || item.id;
    if (timeEntryId) {
      context.onNavigate(`/time-tracking/entries/${timeEntryId}`);
    } else {
      context.onToast("No time entry ID available", "warning");
    }
  },

  // View activity details
  viewActivity: async (item, context) => {
    const activityId = item.activity_id || item.id;
    if (activityId) {
      context.onNavigate(`/communications/${activityId}`);
    } else {
      context.onToast("No activity ID available", "warning");
    }
  },

  // View employee details
  viewEmployee: async (item, context) => {
    const employeeId = item.employee_id || item.user_id || item.id;
    if (employeeId) {
      context.onNavigate(`/employees/${employeeId}`);
    } else {
      context.onToast("No employee ID available", "warning");
    }
  },

  // View company details (when the item IS a company or has a linked company)
  viewCompany: async (item, context) => {
    // For contacts, use the linked company_id; for companies, use the id
    const companyId = item.company_id || item.id;
    if (companyId) {
      context.onNavigate(`/companies/${companyId}`);
    } else {
      context.onToast("No company ID available", "warning");
    }
  },

  // View the company's live Google support-group inbox (triage before a
  // ticket exists). Same-entity (company) fast path: navigate straight to the
  // company detail page's Support Inbox tab. Cross-entity invocations
  // (contact/ticket) route through the resolver's client-redirect manifest
  // (lib/actions/manifests/viewSupportInbox.ts), which resolves the company
  // first, then navigates here.
  viewSupportInbox: async (item, context) => {
    const companyId = item.company_id || item.id;
    if (companyId) {
      context.onNavigate(`/companies/${companyId}?tab=support-inbox`);
    } else {
      context.onToast("No company ID available", "warning");
    }
  },
};
